module.exports = __webpack_public_path__ + "img/link.29aea3bb.svg";